<div class="paginator">
  <div class="paginator-left">
    <span class="paginator-label">
      {{ total() }} {{ entityLabel }}
    </span>
    <span class="paginator-divider">|</span>
    <span class="paginator-label">
      {{ 'pagination.pageOf' | translate:{ page: page() + 1, total: totalPages } }}
    </span>
  </div>

  <div class="paginator-right">
    <span class="paginator-label">{{ 'pagination.rows' | translate }}:</span>
    <select
      [value]="pageSize()"
      (change)="onPageSizeChange($event)"
      class="paginator-select"
    >
      <option value="5">5</option>
      <option value="10">10</option>
      <option value="25">25</option>
      <option value="50">50</option>
    </select>

    <div class="paginator-buttons">
      <button
        class="paginator-btn"
        (click)="previousPage()"
        [disabled]="!hasPreviousPage"
        [attr.aria-label]="'pagination.previous' | translate"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>

      @for (pageNum of pageNumbers; track pageNum) {
        <button
          class="paginator-btn"
          [class.paginator-btn--active]="pageNum === page()"
          (click)="goToPage(pageNum)"
          [attr.aria-current]="pageNum === page() ? 'page' : null"
        >
          {{ pageNum + 1 }}
        </button>
      }

      <button
        class="paginator-btn"
        (click)="nextPage()"
        [disabled]="!hasNextPage"
        [attr.aria-label]="'pagination.next' | translate"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>
</div>
